import React from 'react'
import { useInvoiceDetailsContext } from '../../screens/Contractor/TabInvoice/InvoiceDetailsContext'
import { Text } from 'react-native'
import { Link } from '../atoms/Link'
import { IconFolderForAlert } from '../../assets/icons'
import { routes } from '@linqpal/models'
import { useNavigation } from '@react-navigation/core'
import { CommonActions } from '@react-navigation/routers'
import { SuccessFailurePrompt } from '../molecules/SuccessFailurePrompt'
import { commonColors } from '@linqpal/common-frontend/src/theme'

export const AddToProjectModal = ({ invoice }) => {
  const {
    addToProjectModalVisibility,
    setAddToProjectModalVisibility,
    setProjectSelectionModalVisibility,
    foundProject,
  } = useInvoiceDetailsContext()

  const navigation = useNavigation()

  const addInvoiceToFoundProject = () => {
    routes.projects
      .add(invoice._id, foundProject._id)
      .then((res) => {
        setAddToProjectModalVisibility(false)
        if (res.project) {
          navigation.dispatch({
            ...CommonActions.reset({
              index: 0,
              routes: [
                {
                  name: 'More',
                  state: {
                    routes: [
                      {
                        name: 'Projects',
                        state: {
                          routes: [
                            {
                              name: 'ProjectStack',
                              state: {
                                routes: [
                                  {
                                    name: 'ProjectDetails',
                                    params: { project: res.project },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            }),
          })
        }
        navigation.dispatch({
          ...CommonActions.reset({
            index: 0,
            routes: [
              {
                name: 'More',
                state: {
                  routes: [
                    {
                      name: 'Projects',
                      state: {
                        routes: [
                          {
                            name: 'ProjectStack',
                            state: {
                              routes: [
                                {
                                  name: 'ProjectDetails',
                                  params: { project: foundProject },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          }),
        })
      })
      .catch((err) => {
        console.log('err', err)
      })
  }
  const message = (
    <Text
      style={{
        color: '#668598',
        maxWidth: '80%',
        fontSize: 16,
        textAlign: 'center',
      }}
    >
      Looks like this invoice{' '}
      {invoice.company_id !== '' ? (
        <Text>
          {' '}
          from{' '}
          <Text style={{ fontWeight: '700' }}>{invoice.company.name} </Text>
        </Text>
      ) : (
        ''
      )}{' '}
      belongs to {foundProject.name} project. Would you like to add this to your
      project?
    </Text>
  )

  const link = (
    <>
      <Text style={{ color: commonColors.textLight }}>Not this project? </Text>
      <Link
        textStyle={{ fontSize: 16 }}
        title="See Project List"
        color={'#00A0F3'}
        onPress={() => {
          setAddToProjectModalVisibility(false)
          setProjectSelectionModalVisibility(true)
        }}
      />
    </>
  )

  return (
    <SuccessFailurePrompt
      visible={addToProjectModalVisibility}
      icon={<IconFolderForAlert style={{ marginTop: 70 }} />}
      title={`Add invoice to ${foundProject.name} project`}
      message={message}
      onDismiss={() => {
        setAddToProjectModalVisibility(false)
      }}
      linkData={{ text: link }}
      buttonData={{
        title: 'Add to project',
        onPress: addInvoiceToFoundProject,
        contentStyle: { width: '100%' },
      }}
      textContentBottomMargin={20}
    />
  )
}
